//Project By :- SagarAnand
//Contact me :- sagaranand03@outlook.com
import App from './App'
import ReactDOM from 'react-dom'
import './index.css'
ReactDOM.render(<App/>, document.querySelector("#root"))